module.exports = __webpack_public_path__ + "static/media/wheel.394b3378.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/wheel.svg
// module id = 320
// module chunks = 0